module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+=''+
((__t=( obj.label ))==null?'':__t)+
'';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/components/devices-filter/templates/filter-multi-select-item.html
// module id = 190
// module chunks = 0